import InfosPasswordLabels from "./InfosPasswordLabels";

export default InfosPasswordLabels;
